import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "data-table__column-selection" };
const _hoisted_2 = {
    key: 0,
    class: "dropdown__item dropdown__item--section"
};
const _hoisted_3 = {
    key: 1,
    class: "dropdown__item dropdown__item--filter"
};
const _hoisted_4 = ["placeholder"];
import { ref, watch } from 'vue';
import AppDropdown from "./AppDropdown.vue";
import Icon from "./Icon.vue";
import DataTableColumnSelectionItem from "./DataTableColumnSelectionItem.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableColumnsSelection',
    props: {
        columns: {}
    },
    emits: [
        'toggle', // change visibility
        'resize', // change size
        'sort' // change column order
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const columnFilter = ref(null);
        const availableColumns = ref([]);
        const selectedColumns = ref([]);
        const availableFilteredColumns = ref([]);
        const dragInProgress = ref(false);
        const dragSourceColumn = ref(null);
        const dragTargetColumn = ref(null);
        watch(() => columnFilter.value, onColumnFilterChange);
        watch(() => props.columns, onColumnsChange);
        refreshSelectedColumns();
        refreshAvailableColumns();
        refreshAvailableFilteredColumns();
        function refreshSelectedColumns() {
            selectedColumns.value = props.columns.filter(col => col.selected);
        }
        function refreshAvailableColumns() {
            availableColumns.value = props.columns.filter(col => !col.selected);
        }
        function refreshAvailableFilteredColumns() {
            availableFilteredColumns.value = props.columns
                .filter(col => !col.selected)
                .filter(col => {
                return !columnFilter.value
                    || (col.label && col.label.toLowerCase().indexOf(columnFilter.value.toLowerCase()) !== -1)
                    || (col.name && col.name.toLowerCase().indexOf(columnFilter.value.toLowerCase()) !== -1);
            });
        }
        function toggleColumn(column) {
            emit('toggle', column);
            refreshSelectedColumns();
            refreshAvailableColumns();
            refreshAvailableFilteredColumns();
        }
        function resizeColumn(column, size) {
            emit('resize', column, size);
        }
        function onColumnsChange() {
            refreshSelectedColumns();
        }
        function onColumnFilterChange() {
            refreshAvailableColumns();
            refreshAvailableFilteredColumns();
        }
        function onDragStart(event) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.dropEffect = 'move';
            // @ts-ignore
            const closestColumn = event.target.closest('[data-column]');
            dragSourceColumn.value = closestColumn ? closestColumn.getAttribute('data-column') : null;
            dragInProgress.value = true;
        }
        function onDragOver(event) {
            event.preventDefault();
            // @ts-ignore
            const closestColumn = event.target.closest('[data-column]');
            dragTargetColumn.value = closestColumn ? closestColumn.getAttribute('data-column') : null;
        }
        function onDragEnd(event) {
            event.preventDefault();
            if (dragTargetColumn.value !== dragSourceColumn.value) {
                const newColumnsOrder = [];
                selectedColumns.value.forEach(column => {
                    // No drag target => Put at the beginning
                    if (dragTargetColumn.value === null && newColumnsOrder.length === 0) {
                        newColumnsOrder.push(dragSourceColumn.value);
                    }
                    // No change
                    if (column.name !== dragSourceColumn.value) {
                        newColumnsOrder.push(column.name);
                    }
                    // Put source column after target column
                    if (column.name === dragTargetColumn.value) {
                        newColumnsOrder.push(dragSourceColumn.value);
                    }
                });
                emit('sort', newColumnsOrder);
            }
            dragInProgress.value = false;
            dragSourceColumn.value = null;
            dragTargetColumn.value = null;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(AppDropdown, {
                    "button-style": "link",
                    position: "left"
                }, {
                    button: _withCtx(() => [
                        _createVNode(Icon, {
                            name: "columns",
                            "icon-style": "light"
                        })
                    ]),
                    menu: _withCtx(() => [
                        _createElementVNode("div", {
                            onDragstart: onDragStart,
                            onDragenter: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"])),
                            onDragover: onDragOver,
                            onDragend: onDragEnd
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["dropdown__item dropdown__item--section", { 'data-table__column-selection-drag-target': dragInProgress.value && dragTargetColumn.value === null }])
                            }, _toDisplayString(_ctx.$t('columns.selected')), 3),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedColumns.value, (col) => {
                                return (_openBlock(), _createBlock(DataTableColumnSelectionItem, {
                                    column: col,
                                    key: col.name,
                                    sortable: true,
                                    resizable: true,
                                    class: _normalizeClass({ 'data-table__column-selection-drag-target': dragTargetColumn.value === col.name }),
                                    onToggle: toggleColumn,
                                    onResize: resizeColumn
                                }, null, 8, ["column", "class"]));
                            }), 128))
                        ], 32),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (availableColumns.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('columns.available')), 1))
                            : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (availableColumns.value.length > 10)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((columnFilter).value = $event)),
                                    placeholder: _ctx.$t('search.placeholder')
                                }, null, 8, _hoisted_4), [
                                    [_vModelText, columnFilter.value]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFilteredColumns.value, (col) => {
                            return (_openBlock(), _createBlock(DataTableColumnSelectionItem, {
                                column: col,
                                key: col.name,
                                sortable: false,
                                resizable: false,
                                onToggle: toggleColumn
                            }, null, 8, ["column"]));
                        }), 128))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
